import React, { useEffect, useState } from "react";
import InnerLayout from "../../../components/layouts/inner-layout";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import { purchaseCreditViewAction } from "../../../redux/actions/purchase-action";
import CreateEditViewPurCredit from "../../../components/purchase-section/purchase-credit-note/create-edit-view-pur-credit";

const ViewPurchaseCredit = () => {
  const { id } = useParams();

  const [orderDetail, setOrderDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(purchaseCreditViewAction(id, onSuccPur, onErrPur));
  }, []);

  const onSuccPur = (data) => {
    setOrderDetail(data?.data?.[0]);
    setLoading(false);
  };

  const onErrPur = (data) => {
    setLoading(false);
  };

  return (
    <InnerLayout backBtn={true} title="Purchase Credit Note View">
      {loading ? (
        <LoadingSpinner />
      ) : (
        <CreateEditViewPurCredit
          // <CreateEditViewPurchaseCredit
           payto={orderDetail?.orderData?.pct_pay_to_address}
          shipto={orderDetail?.orderData?.pct_ship_to_address}
          pageType="purchase credit"
          page="view"
          disabled={true}
          data={orderDetail}
          orderDetail={orderDetail?.itemData}
          vendorDetails={[orderDetail?.orderData]}
        />
      )}
    </InnerLayout>
  );
};

export default ViewPurchaseCredit;
